module.exports = __webpack_public_path__ + "static/media/icon-time.d843abe1.svg";